export const theme = {
  color: {
    background: 'white',
    text: '#0a0a0a',
  },
  grid: {
    resolution: 12,
    breakpoints: {
      xs: [null, 767],
      sm: [768, 991],
      md: [992, 1199],
      lg: [1200, null],
    },
  },
  font: {
    large: '1.6rem',
    medium: '1.4rem',
    standard: '1.1rem',
    small: '0.8rem',
  },
}
